import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { formatPriceToParts } from "../../../../helpers/currency/index.js";
import { genKey } from "../../../../helpers/keys.js";
import * as S from "./styled.js";
export const PriceWithCurrency = ({ props , className  })=>{
    const { price =0 , currency ='EUR' , locale ='es-ES' , minimumFractionDigits =0  } = props;
    const priceParts = formatPriceToParts(price, currency, locale, minimumFractionDigits);
    // Var to check not currency price length
    let priceLenghtWithoutCurrency = 0;
    // Types to check
    const types = [
        'integer',
        'group',
        'decimal'
    ];
    // Formatted price with the currency
    const priceFormatted = priceParts.map(({ type , value  }, index)=>{
        if (types.includes(type)) priceLenghtWithoutCurrency += value.length;
        switch(type){
            case 'currency':
                {
                    const currencyClassName = `currency ${value.length >= 3 && 'small'}`;
                    return /*#__PURE__*/ _jsx(S.Currency, {
                        className: currencyClassName,
                        children: value
                    }, genKey(`${index}`));
                }
            // Removes white spaces between price and currency
            case 'literal':
                return null;
            default:
                return /*#__PURE__*/ _jsx(React.Fragment, {
                    children: value
                }, genKey(`${index}`));
        }
    });
    return /*#__PURE__*/ _jsx(S.Price, {
        className: className,
        $size: priceLenghtWithoutCurrency,
        children: priceFormatted
    });
};
export default PriceWithCurrency;

//# sourceMappingURL=index.js.map